import { DoctorMSStateInsurance } from "lib/graphql/megaSchema";

export const insuredInMap: Record<DoctorMSStateInsurance, string> = {
  ZUS: "ZUS",
  KRUS: "KRUS",
  OTHER_COUNTRY: "W innym państwie",
  OTHER_IN_POLAND: "Inne w Polsce",
};
